import styled from 'styled-components';
import { ArrowLeftOutlined } from '@ant-design/icons';

export const ThemeColors = { 
  background: "transparent",     
  backButton: "#F4A261",            // Naranja claro para el botón de regreso
  logrosHeaderText: "#F4A261",      // Naranja claro para el texto del encabezado
  logrosCardBackground: "#2C3E50",  // Marrón grisáceo para las tarjetas
  logrosCardText: "#FFE8D6",        // Blanco cálido para el texto de las tarjetas
  logrosContentBorder: "#FFE8D6"    // Borde blanco cálido para el contenido
};

export const Container = styled.div`
  min-height: 100vh;
  padding: 20px;
  background-color: ${ThemeColors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BackButton = styled(ArrowLeftOutlined)`
  font-size: 24px;
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;
  color: ${ThemeColors.backButton};
`;

export const LogrosHeader = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  color: ${ThemeColors.logrosHeaderText};
`;

export const LogrosCard = styled.div`
  width: 100%;
  background-color: ${ThemeColors.logrosCardBackground};
  border-radius: 10px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  color: ${ThemeColors.logrosCardText};
`;

export const LogrosContent = styled.div`
  padding: 10px 0;
  
  p {
    margin: 0;
    padding: 5px 0;
    border-bottom: 1px solid ${ThemeColors.logrosContentBorder};
    color: ${ThemeColors.logrosCardText};
  }
`;